import { environment } from './environment';
import { Brand } from './brand.model';

export { Brand };

/** Returns the brand whose appUrl host matches the current URL, falling back to environment.defaultBrand. */
export function getBrand(): Brand {
  const host = window.location.host;
  const match = Object.values(environment.brands)
    .find(brand => new URL(brand.appUrl).host === host);
  return match || environment.brands[environment.defaultBrand];
}
